export default __webpack_public_path__ + "static/media/basic_1.2161e6bc.jpg";